export class Product {
  articleNumber = '';
  productName = '';
  brandName = '';
  shelfLifeAfterProduction = null;
  shelfLifeAfterArrival = null;
  startDate = '';
  targetMarket = '';
  percentageOfAlcoholByVolume = '';
  constructor() {}
}
